// P2 Service — agent IA conversationnel + mini-questionnaire.
// Bind les pills de type, le bouton "Analyser", et la conversation chat.
// Met à jour S.service.* au fur et à mesure et active btnNx2 quand
// l'estimation est complète.

import { S } from './state.js';
import { $, $$ } from './dom.js';
import { apiPost } from './api.js';
import { FANUC_MODELS } from './data.js';
import { HOURS_PER_DAY } from './config.js';

function fr() { return S.lang === 'fr'; }
function t( textFr, textEn ) { return fr() ? textFr : textEn; }

// Enable the "Choose a date" button once the AI estimate is in.
// In the 6-step flow that's btnNx4 (leaving the AI Triage step); legacy
// 4-step / older markup may still expose btnNx2.
function setEstimateReadyEnabled( enabled ) {
	[ 'btnNx4', 'btnNx2' ].forEach( function ( id ) {
		var btn = $( id );
		if ( btn ) btn.disabled = ! enabled;
	} );
}

function appendChatBubble( role, content ) {
	var log = $( 'svcChatLog' );
	if ( ! log ) return;
	var row = document.createElement( 'div' );
	row.className = 'svc-chat-row row-' + role;

	// Compact 24px avatar — "AI" cyan circle for assistant, user initials for the customer.
	var avatar = document.createElement( 'span' );
	avatar.className = 'svc-chat-avatar-sm';
	avatar.setAttribute( 'aria-hidden', 'true' );
	if ( role === 'assistant' ) {
		avatar.textContent = 'AI';
	} else {
		// Try to derive initials from the contact name fields.
		var fn = ( document.getElementById( 'inFname' ) || {} ).value || '';
		var ln = ( document.getElementById( 'inLname' ) || {} ).value || '';
		var initials = ( fn.charAt( 0 ) + ln.charAt( 0 ) ).toUpperCase();
		avatar.textContent = initials || 'YOU';
	}

	var col = document.createElement( 'div' );
	col.className = 'svc-chat-col';

	var bubble = document.createElement( 'div' );
	bubble.className = 'svc-chat-bubble svc-chat-' + role;
	bubble.textContent = content;
	col.appendChild( bubble );

	row.appendChild( avatar );
	row.appendChild( col );
	log.appendChild( row );
	log.scrollTop = log.scrollHeight;
}

function showTyping( show ) {
	var t = $( 'svcChatTyping' );
	if ( t ) t.style.display = show ? 'flex' : 'none';
}

function showChat() {
	var chat = $( 'svcChat' );
	if ( chat ) chat.style.display = 'block';
}

function showChatInput( show ) {
	var inp = $( 'svcChatInput' );
	if ( inp ) inp.style.display = show ? 'flex' : 'none';
	var hint = $( 'svcChatHint' );
	if ( hint ) hint.style.display = show ? 'block' : 'none';
}

function showAnalyzeBtn( show ) {
	var acts = $( 'svc-analyze-acts' );
	if ( acts ) acts.style.display = show ? 'flex' : 'none';
}

function setAnalyzeBusy( busy ) {
	var btn = $( 'btnSvcAnalyze' );
	if ( ! btn ) return;
	if ( busy ) {
		btn.disabled = true;
		btn.dataset.origHtml = btn.innerHTML;
		btn.innerHTML = '<span class="spin" style="border-color:rgba(255,255,255,.3);border-top-color:#fff;vertical-align:middle;margin-right:6px"></span>'
			+ t( 'Analyse en cours…', 'Analyzing…' );
	} else {
		btn.disabled = false;
		if ( btn.dataset.origHtml ) {
			btn.innerHTML = btn.dataset.origHtml;
		}
	}
}

function setSendBusy( busy ) {
	var btn = $( 'btnSvcChatSend' );
	if ( ! btn ) return;
	if ( busy ) {
		btn.disabled = true;
		btn.dataset.origHtml = btn.innerHTML;
		btn.innerHTML = '<span class="spin" style="border-color:rgba(255,255,255,.3);border-top-color:#fff;vertical-align:middle;margin-right:6px"></span>'
			+ t( 'Envoi…', 'Sending…' );
	} else {
		btn.disabled = false;
		if ( btn.dataset.origHtml ) {
			btn.innerHTML = btn.dataset.origHtml;
		}
	}
}

// Display estimate in DAYS (the tech's day is committed even for short jobs).
// Hours stay on S.service.estimatedHours for backend pricing.
// Threshold for the "½ jour" label is half a tech-day (HOURS_PER_DAY/2),
// so it scales when the WP setting changes (e.g. 6h or 10h workdays).
function hoursToDayLabel( hours, fr ) {
	if ( ! hours || hours <= 0 ) return { num: '—', unit: fr ? 'jour(s)' : 'day(s)' };
	if ( hours < HOURS_PER_DAY / 2 ) return { num: '½', unit: fr ? 'jour' : 'day' };
	var days = Math.ceil( hours / HOURS_PER_DAY );
	var unit = days > 1 ? ( fr ? 'jours' : 'days' ) : ( fr ? 'jour' : 'day' );
	return { num: String( days ), unit: unit };
}

function renderEstimate( hours, confidence, summary ) {
	var box = $( 'svcEstimate' );
	var txt = $( 'svcEstimateText' );
	var conf = $( 'svcEstimateConfidence' );
	var hoursEl = $( 'svcEstimateHours' );
	var unitEl  = $( 'svcEstimateUnit' );
	if ( ! box ) return;
	box.style.display = 'block';

	var dayInfo = hoursToDayLabel( hours, fr() );
	if ( hoursEl ) hoursEl.textContent = dayInfo.num;
	if ( unitEl )  unitEl.textContent  = dayInfo.unit;

	// Confidence badge — Direction A layout uses an inner .srd-estimate-conf-text span.
	var confLabels = {
		low:    t( 'Confiance : faible', 'Confidence: low' ),
		medium: t( 'Confiance : moyenne', 'Confidence: medium' ),
		high:   t( 'Confiance : élevée', 'Confidence: high' ),
	};
	if ( conf ) {
		var inner = conf.querySelector( '.srd-estimate-conf-text' );
		if ( inner ) {
			inner.textContent = confLabels[ confidence ] || confLabels.medium;
		} else {
			conf.textContent = confLabels[ confidence ] || confLabels.medium;
		}
	}

	if ( txt ) {
		txt.textContent = summary || '';
	}

	// Time stamp (Direction A: small "Generated · 14:32" line under reference)
	var timeEl = document.getElementById( 'srdEstimateTime' );
	if ( timeEl ) {
		var d = new Date();
		var hh = String( d.getHours() ).padStart( 2, '0' );
		var mm = String( d.getMinutes() ).padStart( 2, '0' );
		var months = t( 'jan|fév|mar|avr|mai|juin|jul|aoû|sep|oct|nov|déc', 'Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec' ).split( '|' );
		timeEl.textContent = ( t( 'Généré', 'Generated' ) ) + ' · ' + months[ d.getMonth() ] + ' ' + d.getDate() + ', ' + hh + ':' + mm;
	}

	// Sidebar mini-estimate — short form ("4 j" / "4 d", "½ j", "—").
	var miniNum = document.getElementById( 'srdEstimateMini' );
	var miniBox = miniNum ? miniNum.closest( '.srd-estimate-mini' ) : null;
	if ( miniNum ) {
		miniNum.textContent = dayInfo.num + ' ' + ( fr() ? 'j' : 'd' );
	}
	if ( miniBox ) miniBox.classList.add( 'has-value' );
}

// ─── Sidebar (.srd-ticket) live updates ──────────────────────────────────
function srdUpdateSidebarFromContact() {
	var get = function ( id ) { var el = document.getElementById( id ); return el ? ( el.value || '' ).trim() : ''; };
	var setText = function ( id, val ) {
		var el = document.getElementById( id );
		if ( ! el ) return;
		if ( val ) {
			el.textContent = val;
			el.classList.remove( 'srd-ticket-empty' );
		} else {
			el.textContent = '—';
			el.classList.add( 'srd-ticket-empty' );
		}
	};
	setText( 'srdCompany', get( 'inCo' ) );
	setText( 'srdContact', ( get( 'inFname' ) + ' ' + get( 'inLname' ) ).trim() );
	// Site = city pulled from address components (set after Places select).
	var c = window.ProbotSoumApp && window.ProbotSoumApp.S && window.ProbotSoumApp.S.addressComponents;
	if ( c && c.city ) {
		setText( 'srdSite', c.city + ( c.state_short ? ', ' + c.state_short : '' ) );
	} else {
		// Fallback: raw address field truncated.
		var addr = get( 'inFactoryAddress' );
		setText( 'srdSite', addr ? addr.split( ',' )[1] ? addr.split( ',' ).slice( 1, 3 ).join( ',' ).trim() : addr : '' );
	}
}

function srdUpdateSidebarRobots() {
	var grp = document.getElementById( 'srdRobotGroup' );
	var modelsEl = document.getElementById( 'srdRobotModels' );
	if ( ! grp ) return;
	var sel = S.selModels || {};
	var ids = Object.keys( sel ).filter( function ( id ) { return ( sel[ id ] || 0 ) > 0; } );
	if ( ! ids.length ) {
		grp.style.display = 'none';
		return;
	}
	grp.style.display = '';
	if ( modelsEl ) {
		// "2× R-2000iC, 1× M-710iC" — keep concise; full list lives in the form.
		var label = ids.map( function ( id ) {
			var qty = sel[ id ] || 0;
			var nice;
			if ( id === 'unknown' )       nice = t( 'Inconnu', 'Unknown' );
			else if ( id === 'noinfonow' ) nice = t( 'À préciser', 'TBD' );
			else if ( id === 'other' )     nice = t( 'Autre', 'Other' );
			else {
				var m = FANUC_MODELS.find( function ( x ) { return x.id === id; } );
				nice = m ? m.name : id;
			}
			return ( qty > 1 ? qty + '× ' : '' ) + nice;
		} ).join( ', ' );
		modelsEl.textContent = label;
	}
}

function srdUpdateSidebarIntervention() {
	var grp = document.getElementById( 'srdInterventionGroup' );
	var typeEl = document.getElementById( 'srdIntType' );
	var type = S.service && S.service.type;
	if ( ! type ) {
		if ( grp ) grp.style.display = 'none';
		return;
	}
	if ( grp ) grp.style.display = '';
	if ( typeEl ) {
		var labels = {
			diagnostic: t( 'Diagnostic', 'Diagnostic' ),
			repair: t( 'Réparation', 'Repair' ),
			integration: t( 'Intégration / programmation', 'Integration / programming' ),
			calibration: t( 'Calibration / mastering', 'Calibration / mastering' ),
			training: t( 'Formation sur site', 'On-site training' ),
			other: t( 'Autre', 'Other' ),
		};
		typeEl.textContent = labels[ type ] || type;
	}
}

function srdUpdateSidebarDate() {
	var grp = document.getElementById( 'srdScheduleGroup' );
	var dateEl = document.getElementById( 'srdDate' );
	var raw = S.selDate;
	if ( ! raw ) {
		if ( grp ) grp.style.display = 'none';
		return;
	}
	if ( grp ) grp.style.display = '';
	if ( dateEl ) {
		// S.selDate is a Date instance (calendar.js stores Date objects);
		// be defensive in case ISO strings show up.
		var d = ( raw instanceof Date ) ? raw : new Date( String( raw ) + 'T00:00:00' );
		if ( isNaN( d.getTime() ) ) { dateEl.textContent = String( raw ); return; }
		dateEl.textContent = d.toLocaleDateString(
			S.lang === 'fr' ? 'fr-CA' : 'en-CA',
			{ weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' }
		);
	}
}

function pushAssistantMsg( content ) {
	S.service.conversation.push( { role: 'assistant', content: content } );
	appendChatBubble( 'assistant', content );
}

function pushUserMsg( content ) {
	S.service.conversation.push( { role: 'user', content: content } );
	appendChatBubble( 'user', content );
}

function applyResult( res ) {
	showTyping( false );
	if ( ! res || ! res.ok ) {
		var raw = res && res.error ? String( res.error ) : '';
		var msg;
		if ( raw.indexOf( 'timeout' ) !== -1 ) {
			msg = t(
				'⏱️ L\'assistant met plus de temps que prévu. Vérifiez votre connexion et réessayez.',
				'⏱️ The assistant is taking longer than expected. Check your connection and try again.'
			);
		} else if ( raw ) {
			msg = '⚠️ ' + raw;
		} else {
			msg = t( '⚠️ Erreur de communication avec l\'assistant.', '⚠️ Assistant communication error.' );
		}
		pushAssistantMsg( msg );
		showChatInput( false );
		// Permet au user de réessayer
		showAnalyzeBtn( true );
		return;
	}
	if ( res.mode === 'question' ) {
		pushAssistantMsg( res.question || t( '(question vide)', '(empty question)' ) );
		showChatInput( true );
		var ta = $( 'inSvcChatReply' );
		if ( ta ) { ta.value = ''; ta.focus(); }
	} else if ( res.mode === 'estimate' ) {
		S.service.estimatedHours   = parseFloat( res.estimated_hours ) || 0;
		S.service.confidence       = res.confidence || 'medium';
		S.service.summary          = res.summary || '';
		S.service.analysisComplete = true;
		renderEstimate( S.service.estimatedHours, S.service.confidence, S.service.summary );
		showChatInput( false );
		setEstimateReadyEnabled( true );
		// Message de clôture
		pushAssistantMsg( t(
			'Estimation préliminaire prête ci-dessous. Vous pouvez passer à l\'étape suivante.',
			'Preliminary estimate ready below. You can proceed to the next step.'
		) );
	} else {
		pushAssistantMsg( t( 'Réponse inattendue de l\'assistant.', 'Unexpected assistant response.' ) );
	}
}

function callEstimate( description, conversation ) {
	return apiPost( 'service-estimate', {
		service_type: S.service.type,
		description:  description,
		conversation: conversation,
		lang:         S.lang || 'fr',
	}, { recaptchaAction: 'service_estimate' } );
}

// startTriage — kicks off the AI analysis. Called either by the legacy
// "Analyze" button (4-step flow) or by the panels.js transition into P4
// (6-step flow, via window.ProbotSoumStartTriage).
function startTriage() {
	var desc = S.service.description || ( ( $( 'inSvcDesc' ) || {} ).value || '' ).trim();
	if ( ! S.service.type || desc.length < 20 ) return;

	S.service.description       = desc;
	S.service.conversation      = [];
	S.service.analysisComplete  = false;
	S.service.estimatedHours    = 0;
	S.service.confidence        = '';
	S.service.summary           = '';
	setEstimateReadyEnabled( false );

	showChat();
	var log = $( 'svcChatLog' );
	if ( log ) log.innerHTML = '';
	var est = $( 'svcEstimate' );
	if ( est ) est.style.display = 'none';

	pushUserMsg( desc );
	showAnalyzeBtn( false );
	setAnalyzeBusy( true );
	showTyping( true );

	callEstimate( desc, [] )
		.catch( function ( e ) { return { ok: false, error: String( e ) }; } )
		.then( function ( res ) {
			setAnalyzeBusy( false );
			applyResult( res );
		} );
}

function onAnalyzeClick() { startTriage(); }
window.ProbotSoumStartTriage = startTriage;
// Lets panels.js re-derive the day label (singular/plural) when the user
// toggles language after the AI estimate has rendered.
window.ProbotSoumRerenderEstimate = function () {
	if ( S.service.analysisComplete ) {
		renderEstimate( S.service.estimatedHours, S.service.confidence, S.service.summary );
	}
};

function onChatSendClick() {
	var ta = $( 'inSvcChatReply' );
	if ( ! ta ) return;
	var reply = ( ta.value || '' ).trim();
	if ( reply.length < 2 ) return;

	pushUserMsg( reply );
	showChatInput( false );
	setSendBusy( true );
	showTyping( true );

	callEstimate( S.service.description, S.service.conversation )
		.catch( function ( e ) { return { ok: false, error: String( e ) }; } )
		.then( function ( res ) {
			setSendBusy( false );
			applyResult( res );
		} );
}


function onTypePillClick( ev ) {
	var btn = ev.target.closest( '[data-ps-svc-type]' );
	if ( ! btn ) return;
	ev.preventDefault();
	var id = btn.getAttribute( 'data-ps-svc-type' );
	S.service.type = id;
	$$( '[data-ps-svc-type]' ).forEach( function ( b ) {
		b.classList.toggle( 'on', b === btn );
	} );
	var typeErr = $( 'f-svc-type' );
	if ( typeErr ) typeErr.classList.remove( 'err' );
	srdUpdateSidebarIntervention();
}

// Sidebar live-update wiring shared by both flows. Hooks contact/site/
// robots/date into the .srd-ticket recap. Service-only fields (intervention
// type) silently no-op when the corresponding DOM nodes are absent.
function bindSrdSidebar() {
	if ( ! document.querySelector( '.is-srd' ) ) return;
	[ 'inFname', 'inLname', 'inCo', 'inFactoryAddress' ].forEach( function ( id ) {
		var el = document.getElementById( id );
		if ( el ) el.addEventListener( 'input', srdUpdateSidebarFromContact );
	} );
	srdUpdateSidebarFromContact();
	srdUpdateSidebarRobots();
	srdUpdateSidebarIntervention();
	srdUpdateSidebarDate();
	// Models / date / address-components mutate via click handlers and
	// async API calls that don't dispatch DOM events — poll cheaply.
	var lastDate = null;
	var lastModelsKey = '';
	setInterval( function () {
		if ( S.selDate !== lastDate ) {
			lastDate = S.selDate;
			srdUpdateSidebarDate();
		}
		var key = JSON.stringify( S.selModels || {} );
		if ( key !== lastModelsKey ) {
			lastModelsKey = key;
			srdUpdateSidebarRobots();
		}
		var c = S.addressComponents;
		if ( c && c.city ) srdUpdateSidebarFromContact();
	}, 600 );
}

export function bindServicePanel() {
	// Sidebar wiring runs for both flows (maintenance + service) when the
	// Direction A shell is in use — extract a shared step before the
	// service-specific bail-out below.
	bindSrdSidebar();

	if ( S.quoteType !== 'service' ) return;

	var grid = document.querySelector( '.svc-type-grid' );
	if ( grid ) grid.addEventListener( 'click', onTypePillClick );

	var btnAnalyze = $( 'btnSvcAnalyze' );
	if ( btnAnalyze ) btnAnalyze.addEventListener( 'click', onAnalyzeClick );

	var btnSend = $( 'btnSvcChatSend' );
	if ( btnSend ) btnSend.addEventListener( 'click', onChatSendClick );

	var inDesc = $( 'inSvcDesc' );
	if ( inDesc ) {
		var counter = document.getElementById( 'svcDescCount' );
		var updateCount = function () {
			if ( counter ) counter.textContent = String( ( inDesc.value || '' ).length );
			var f = $( 'f-svc-desc' );
			if ( f ) f.classList.remove( 'err' );
		};
		inDesc.addEventListener( 'input', updateCount );
		updateCount();
	}

	// Enter envoie le message ; Shift+Enter insère un saut de ligne.
	var inReply = $( 'inSvcChatReply' );
	if ( inReply ) {
		inReply.addEventListener( 'keydown', function ( ev ) {
			if ( ev.key === 'Enter' && ! ev.shiftKey && ! ev.isComposing ) {
				ev.preventDefault();
				onChatSendClick();
			}
		} );
	}
}
